import { Box, Paper, Typography } from '@/shared/ui';

import { TERMS_VERSION } from '@/config/constants';
import { DateTextVariants, useDateText, useUserDetails } from '@/features/_shared/user';
import Button from '@/shared/ui/primitives/Button';

const Terms = () => {
  const { terms } = useUserDetails();
  const { formatDateString } = useDateText();
  return (
    <Box
      component={Paper}
      sx={{
        display: 'flex',
        alignItems: { xs: 'center', md: 'center' },
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: { xs: 'center', md: 'space-between' },
        p: 3,
        width: '100%',
        gap: 2,
        position: { xs: 'static', md: 'relative' }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: { xs: 'center', md: 'flex-start' }
        }}
      >
        <Typography variant='h6'>Terms & Conditions</Typography>
        <Typography
          sx={{ color: 'gx.textDisabled' }}
          variant='body2'
        >
          Version {TERMS_VERSION}
        </Typography>
      </Box>
      <Typography
        sx={{
          position: { xs: 'static', md: 'absolute' },
          left: { md: '50%' },
          top: { md: '50%' },
          transform: { md: 'translate(-50%, -50%)' },
          textAlign: { xs: 'center', md: 'inherit' },
          mt: { xs: 1, md: 0 }
        }}
        variant='body2'
      >
        {terms ? <>Signed {formatDateString(terms, DateTextVariants.WITH_TIME)}</> : 'Not Signed'}
      </Typography>
      <Box sx={{ width: { xs: '100%', md: '113px' } }}>
        <Button
          fullWidth
          color='secondary'
          component='a'
          download={`terms_${TERMS_VERSION}.pdf`}
          href='/terms.pdf'
          size='small'
          target='_blank'
          variant='text'
        >
          Download
        </Button>
      </Box>
    </Box>
  );
};

export default Terms;
